module.exports = __webpack_public_path__ + "static/media/Doris M.c79c14ce.jpeg";